export default __webpack_public_path__ + "static/media/3bgfree.359db626.png";